export default __webpack_public_path__ + "static/media/tornado.0061b1ab.svg";